var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EEFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2646 15.3397C13.3836 14.3983 14.6071 13.1189 15.578 13.2609L15.5764 13.2593C16.5214 13.4389 17.2694 15.0652 17.6911 15.7965C17.99 16.3271 17.7959 16.8647 17.5172 17.0915C17.1411 17.3946 16.5531 17.8128 16.6765 18.2327C16.8958 18.9792 19.5 21.5833 20.7808 22.3236C21.2656 22.6039 21.6172 21.8648 21.9174 21.4861C22.1355 21.1949 22.6735 21.0208 23.2029 21.3083C23.9935 21.7688 24.7383 22.3039 25.4271 22.9062C25.771 23.1938 25.8518 23.6186 25.6134 24.0677C25.1936 24.8586 23.9795 25.9017 23.0981 25.6897C21.5588 25.3196 15.3333 22.9062 13.3337 15.9146C13.2212 15.5838 13.2495 15.4588 13.2646 15.3397Z",
    fill: "#00BF62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5001 30.9582C18.2255 30.9582 17.5203 30.8214 16.3751 30.4373L14.1818 31.534C12.7966 32.2266 11.1667 31.2193 11.1667 29.6706V27.3123C8.92357 25.2207 8.04175 22.8089 8.04175 19.4998C8.04175 13.1716 13.1718 8.0415 19.5001 8.0415C25.8283 8.0415 30.9584 13.1716 30.9584 19.4998C30.9584 25.8281 25.8283 30.9582 19.5001 30.9582ZM13.2501 26.4064L12.5875 25.7886C10.8447 24.1636 10.1251 22.3468 10.1251 19.4998C10.1251 14.3222 14.3224 10.1248 19.5001 10.1248C24.6778 10.1248 28.8751 14.3222 28.8751 19.4998C28.8751 24.6775 24.6778 28.8748 19.5001 28.8748C18.4733 28.8748 17.9917 28.7821 17.0375 28.4621L16.2172 28.187L13.2501 29.6706V26.4064Z",
    fill: "#00BF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatsicon);
export default __webpack_public_path__ + "static/media/watsicon.cdd7dc4ccea5318538b550f6294dcba3.svg";
export { ForwardRef as ReactComponent };